// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import {
    RouteComponentProps,
    withRouter,
} from 'react-router';
import { Link } from '@plesk/ui-library';
import { VM_TABS } from 'admin/computeResourceVm/constants';
import { Link as RouterLink } from 'react-router-dom';
import { pathTo } from 'common/helpers/core';

export interface IComputeResourceVmLinkProps extends RouteComponentProps {
    id: number;
    children?: React.ReactElement | string;
    tab?: string;
}

export const ComputeResourceVmLink: React.FC<IComputeResourceVmLinkProps> = ({
    id,
    history,
    children,
    tab,
}) => {
    tab = tab ?? VM_TABS.RESCUE_TAB;

    // Remove leading '#'.
    if (tab[0] === '#') {
        tab = tab.slice(1);
    }

    return (
        <Link
            component={RouterLink}
            to={pathTo(`servers/${id}#${tab}`)}
        >
            {children}
        </Link>
    );
};

export default withRouter(ComputeResourceVmLink);
